import { styled } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const ProductModalMain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 32px;
  margin-bottom: 32px;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #f2f2f2;
  color: ${props => props.theme.color.black};
`
export const ProductModalMainImage = styled.div`
  width: 220px;
  height: 220px;
  margin-right: 48px;
`
export const ProductModalMainContent = styled.div`
  flex: 1;
  max-width: 60%;
`
export const ProductModalMainContentTitle = styled.h4`
  font-family: ${props => props.theme.font.secondary};
  font-size: 42px;
  color: ${props => props.theme.color.black};
`
export const ProductModalMainContentCaption = styled.p`
  font-size: 18px;
  color: ${props => props.theme.color.black};
  opacity: 0.5;
`

// Variants

export const ProductModalVariants = styled.div`
  display: flex;
  flex-direction: row;
`

export const ProductModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${props => props.theme.color.black};
`

export const ProductModalFooterTotal = styled.div`
  color: ${props => props.theme.color.primary};
  font-size: 36px;
  font-weight: 600;
  margin-left: auto;
  margin-right: 30px;
`

export const ProductVariantWrapper = styled.button`
  ${Reset('button')}
  flex: 50%;
  max-width: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  opacity: ${props => (props.active ? 1 : 0.75)};
`

export const ProductVariantImage = styled.img`
  width: 130px;
  height: 130px;
`

export const ProductVariantContent = styled.div`
  display: flex;
  padding-left: 16px;
  padding-right: 16px;
  flex: 1;
  flex-direction: row;
`

export const ProductVariantContentCheckbox = styled.div`
  margin-right: 16px;
`

export const ProductVariantContentBody = styled.div``

export const ProductVariantTitle = styled.div`
  font-family: ${props => props.theme.font.secondary};
  color: ${props => props.theme.color.black};
  font-size: 19px;
  margin-bottom: 0px;
`

export const ProductVariantCaption = styled.div`
  color: ${props => props.theme.color.black};
  opacity: 0.5;
  margin-bottom: 10px;
`

export const ProductVariantPrice = styled.div`
  font-weight: 600;
  color: ${props => props.theme.color.primary};
  font-size: 19px;
`

// Addons

export const ProductModalAddonsWrapper = styled.div`
  margin: 0 0 32px;
  padding: 0 0 16px;
`

export const ProductModalAddonsHeader = styled.div`
  margin-bottom: 20px;
`

export const ProductModalAddonsTitle = styled.div`
  font-family: ${props => props.theme.font.secondary};
  font-size: 24px;
  color: ${props => props.theme.color.black};
  font-weight: 400;
`

export const ProductModalAddonsScroll = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 50px;
  margin: 0 -50px;
`

export const ProductModalAddonsList = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  border-bottom: 1px solid ${props => props.theme.color.lineDark};
  width: 100%;
  padding-bottom: 2rem;
`

export const ProductAddonWrapper = styled.button`
  ${Reset('button')}
  position: relative;
  display: flex;
  width: 260px;
  flex-shrink: 0;
  margin-right: 20px;
  padding: 0 20px;
  height: 92px;
  flex-direction: row;
  overflow: visible;
  align-items: center;
  opacity: ${props => (props.active ? 1 : 0.75)};
`

export const ProductAddonOutline = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  border: 2px solid ${props => props.theme.color.primary};
  opacity: 0;
`

export const ProductAddonBorder = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  border: 1px solid ${props => props.theme.color.lineDark};
  z-index: 2;
`

export const ProductAddonCheckbox = styled.div`
  margin-right: 0.5rem;
`

export const ProductAddonBody = styled.div``

export const ProductAddonTitle = styled.div`
  color: ${props => props.theme.color.black};
  font-weight: 500;
`

export const ProductAddonCaption = styled.div`
  color: ${props => props.theme.color.black};
  font-size: 14px;
  opacity: 0.5;
`

export const ProductAddonPrice = styled.div`
  color: ${props => props.theme.color.primary};
  font-weight: 600;
  margin-left: auto;
  padding-left: 16px;
`
